
    import { mapActions, mapState } from 'vuex';
    import ResumeWritePurchaseOptionLong from '@/components/ResumeWriting/ResumeWritePurchaseOptionLong';
    import ResumeWritePurchaseOptionStacked from '@/components/ResumeWriting/ResumeWritePurchaseOptionStacked';
    import SectionReviewRow from '@/components/ResumeWriting/LandingSections/SectionReviewRow';
    import SectionReviewStacked from '@/components/ResumeWriting/LandingSections/SectionReviewStacked';
    import SectionTestimonials from '@/components/ResumeWriting/LandingSections/SectionTestimonials';
    import SectionTrustedBy from '@/components/ResumeWriting/LandingSections/SectionTrustedBy';
    import SectionFaq from '@/components/ResumeWriting/LandingSections/SectionFaq';
    import SectionHowItWorks from '@/components/ResumeWriting/LandingSections/SectionHowItWorks';
    import datalayer from '@/utils/datalayer';

    export default {
        layout: 'discovery',

        components: {
            ResumeWritePurchaseOptionLong,
            ResumeWritePurchaseOptionStacked,
            SectionReviewRow,
            SectionReviewStacked,
            SectionTestimonials,
            SectionTrustedBy,
            SectionFaq,
            SectionHowItWorks,
        },

        async fetch({ store }) {
            if (store.state.me.user.id) {
                await store.dispatch('me/syncScoring');
            }
        },

        data() {
            return {
                sections: [],
                isHowItWorkAnimate: false,
                isTestimonialsAnimate: false,
                impressions: {
                    bottomCta: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_scoringData: state => state.me.scoringData,
            }),
        },

        mounted() {
            this.initScrollToSections();
        },

        methods: {
            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),
            async pushEvent(data) {
                datalayer(data);
                return await this.$_pushEvent(data).catch(e => undefined);
            },
            async pushEventClick($e, data) {
                const url = $e.currentTarget.getAttribute('href');
                const isShortcutKeyPressed = $e.ctrlKey || $e.shiftKey || $e.metaKey;
                const isMiddleButtonPressed = $e.button === 1;
                const isRightButtonPressed = $e.button === 2;

                if (isRightButtonPressed) {
                    return false;
                }

                await this.pushEvent(data);

                if (isShortcutKeyPressed || isMiddleButtonPressed) {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
            },
            initScrollToSections() {
                this.sections = [
                    {
                        element: this.$refs.uspSection1,
                        callback: vm => this.uspSection1Callback(vm),
                        isCompleted: false,
                    },
                    {
                        element: this.$refs.uspSection2,
                        callback: vm => this.uspSection2Callback(vm),
                        isCompleted: false,
                    },
                    {
                        element: this.$refs.uspSection3,
                        callback: vm => this.uspSection3Callback(vm),
                        isCompleted: false,
                    },
                    {
                        element: this.$refs.howItWorksSection,
                        callback: vm => this.howItWorksSectionCallback(vm),
                        isCompleted: false,
                    },
                    {
                        element: this.$refs.testimonialsSection,
                        callback: vm => this.testimonialsSectionCallback(vm),
                        isCompleted: false,
                    },
                    {
                        element: this.$refs.bottomCtaSection,
                        callback: vm => this.bottomCtaSectionCallback(vm),
                        isCompleted: false,
                    },
                ];

                if (this.$mq === 'inf' && this.isScrolledIntoView(this.sections[0].element)) {
                    this.sections[0].callback(this.sections[0]);
                }

                window.addEventListener('scroll', (event) => {
                    for (const section of this.sections) {
                        if (this.isScrolledIntoView(section.element) && !section.isCompleted) {
                            section.callback(section);
                        }
                    }
                }, false);
            },

            uspSectionAnimation(section) {
                if (section.isCompleted) {
                    return false;
                }
                const vm = this;
                this.$velocity(section.element, {
                    opacity: 1,
                }, {
                    easing: 'easeIn',
                    duration: 500,
                    begin(elem) {
                        vm.$velocity(elem, {
                            translateY: '-40px',
                        }, {
                            easing: 'easeIn',
                            duration: 200,
                            queue: false,
                        });
                    },
                });
            },

            uspSection1Callback(section) {
                this.uspSectionAnimation(section);
                section.isCompleted = true;
                this.pushEvent({
                    event: 'ad_impression',
                    code: 'topresume',
                    site_position: 'resume_writing_inline_targeted_resume',
                    cta: 'Tell your story',
                    seeker_data: this.$_scoringData,
                });
            },

            uspSection2Callback(section) {
                this.uspSectionAnimation(section);
                section.isCompleted = true;
                this.pushEvent({
                    event: 'ad_impression',
                    code: 'topresume',
                    site_position: 'resume_writing_inline_unleash_your_potential',
                    cta: 'Discover your potential',
                    seeker_data: this.$_scoringData,
                });
            },

            uspSection3Callback(section) {
                this.uspSectionAnimation(section);
                section.isCompleted = true;
                this.pushEvent({
                    event: 'ad_impression',
                    code: 'topresume',
                    site_position: 'resume_writing_inline_One-on-one-support',
                    cta: 'Work with a professional',
                    seeker_data: this.$_scoringData,
                });
            },

            howItWorksSectionCallback(section) {
                setTimeout(() => {
                    this.isHowItWorkAnimate = true;
                }, 200);
                section.isCompleted = true;
                this.pushEvent({
                    event: 'ad_impression',
                    code: 'topresume',
                    site_position: 'resume_writing_inline_how_does_it_work',
                    cta: 'Get matched with an expert',
                    seeker_data: this.$_scoringData,
                });
            },

            testimonialsSectionCallback(section) {
                setTimeout(() => {
                    this.isTestimonialsAnimate = true;
                }, 400);
                section.isCompleted = true;
                this.pushEvent({
                    event: 'ad_impression',
                    code: 'topresume',
                    site_position: 'resume_writing_inline_testimonials',
                    cta: 'Experience the difference',
                    seeker_data: this.$_scoringData,
                });
            },

            bottomCtaSectionCallback(section) {
                this.impressions.bottomCta = true;
                section.isCompleted = true;
            },

            isScrolledIntoView(element, event) {
                if (!element) {
                    return false;
                }
                const bounding = element.getBoundingClientRect();
                return bounding.top <= window.innerHeight;
            },
        },

        head() {
            return {
                title: `Resume writing | ${this.$siteName}`,
                meta: [
                    { hid: 'og:title', property: 'og:title', content: 'resume writing' },
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'Land your next job faster',
                    },
                    {
                        hid: 'og:description',
                        property: 'og:description',
                        content: `Land your next job faster with ${this.$siteName}.`,
                    },
                ],
            };
        },
    };
